<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<p *ngIf="ownershipLevel[$.row![$.adata.fetch_key]]; else dash">{{ownershipLevel[$.row![$.adata.fetch_key]]}}</p>
<ng-template #dash>
  <p>-</p>
</ng-template>
</ng-container>
